import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import UploadIcon from "@mui/icons-material/Upload";
import { useDispatch, useSelector } from "react-redux";
import { uploadMedia } from "../mediaSlice";
import { inputSx, withCdn } from "../blogTheme";
import { BlogImage } from "./BlogImage";

export function ImageBlockUploader({ onUpload, label = "Upload Image", existingUrl, postId }) {
  const dispatch = useDispatch();
  const uploading = useSelector((state) => state.media.uploading);
  const fileRef = useRef(null);
  const [preview, setPreview] = useState(existingUrl ? withCdn(existingUrl) : null);
  const [alt, setAlt] = useState("");

  useEffect(() => {
    setPreview(existingUrl ? withCdn(existingUrl) : null);
  }, [existingUrl]);

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    if (alt) formData.append("alt", alt);
    if (postId) formData.append("postId", postId);
    const result = await dispatch(uploadMedia(formData));
    if (uploadMedia.fulfilled.match(result)) {
      const media = result.payload?.media || result.payload;
      if (media?.url) {
        const cdnUrl = withCdn(media.url);
        setPreview(cdnUrl);
        if (onUpload) onUpload(media.url, media);
      }
    }
  };

  return (
    <Box>
      <input ref={fileRef} type="file" accept="image/*" hidden onChange={handleFile} />
      <Button
        startIcon={uploading ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : <UploadIcon />}
        onClick={() => fileRef.current?.click()}
        disabled={uploading}
        sx={{
          background: "linear-gradient(180deg, #065F46 0%, #0D7B5C 100%)",
          color: "#fff",
          borderRadius: "29px",
          boxShadow: "1px 2px 30px 0px rgba(0,0,0,0.06)",
          fontFamily: "Heebo",
          px: 3,
          "&:hover": { opacity: 0.9 },
          "&:disabled": { opacity: 0.6 },
        }}
      >
        {label}
      </Button>
      {preview && (
        <BlogImage
          src={preview}
          alt={alt || "preview"}
          width="100%"
          height={160}
          borderRadius="12px"
          objectFit="contain"
          sx={{ mt: 1, bgcolor: "#F9FAFB" }}
        />
      )}
      <TextField
        label="Alt text"
        value={alt}
        onChange={(e) => setAlt(e.target.value)}
        size="small"
        fullWidth
        sx={{ mt: 1, ...inputSx }}
      />
    </Box>
  );
}
